<div class="page_wrapper">
  <div class="container-fluid wrapper-page header-fix-1 position-relative display-contents">
    <div class="row">
      <div class="col-lg-12 pl-0 pr-0">
        <div class="card">
          <div class="row ml-3 mr-0 p-3">
            <div class="col-md-8">
              <div class="wh">
                <a href="{{homePageUrl}}" class="link-hover">
                  <img src="/assets/images/logo1.svg" />
                </a>
              </div>
              <div class="d-flex">
                <img src="/assets/images/telephone.png" class="d-inline wh-22" />
                <span class="ml-1"> {{ defaultContact }}</span>
              </div>
              <div class="d-flex">
                <i class="fa fa-envelope ml-1 mt-1" aria-hidden="true"></i>
                <span class="ml-1">{{ defaultEmail }}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div>
                <p class="m-0 mb-1 p-blue text-capitalize">
                  {{ physician?.title }} {{ physician?.first_name }}
                  {{ physician?.last_name }}
                </p>
                <p class="m-0 mb-1 p-blue">
                  {{ physician?.qualification }}
                </p>
                <p class="m-0 mb-1 p-blue">{{ physician_model?.speciality }}</p>
                <p class="m-0 mb-1 p-blue">
                  Registration No.: {{ physician?.r_no }}
                </p>
                <p class="m-0 mb-1 p-blue text-capitalize">
                  {{ physician?.city }}{{ physician_model?.location }}
                  {{ physician?.zip }}
                </p>
              </div>
            </div>
            <!-- </div> -->
            <hr />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid wrapper-page header-fix-1 position-relative display-contents">
    <div class="row">
      <div class="col-lg-12 pl-0 pr-0">
        <div class="card border-0">
          <div class="row ml-3 mr-0 p-3">
            <div class="col-md-8">
              <div class="font-size-14">
                <span class="p-blue font-weight-bold">Name: </span>
                <span class="font-weight-500 text-capitalize">
                  {{ patient?.first_name }} {{ patient?.last_name }}
                </span>
              </div>

              <div class="font-size-14">
                <span class="p-blue font-weight-bold">Age /Gender: </span>
                <span class="font-weight-500 text-capitalize">{{ patient?.age }} / {{ patient?.gender }}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div>
                <div class="font-size-14">
                  <span class="p-blue font-weight-bold">Consult Type: </span>
                  <span class="font-weight-500 text-capitalize">{{
                    appointment?.apttype
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid wrapper-page header-fix-1 position-relative display-contents">
    <div class="row">
      <div class="col-lg-12 pl-0 pr-0">
        <div class="card border-0">
          <div class="card-body p-5">
            <div class="row">
              <div class="col-lg-6"></div>
            </div>
            <p class="font-weight-bold p-blue" *ngIf="invoice && invoice?.id">
              Invoice ID:
              <small class="font-size-14 color">{{ invoice?.id }}</small> <br />
              <small class="font-size-14 color">Reliable Doctors Appointment Booking</small>
            </p>
            <div [ngClass]="invoice && invoice?.id ? 'mt-5' : 'mt-0'">
              <p class="p-blue font-weight-bold">
                AMOUNT PAID
                <span class="font-weight-500 color">
                  {{ invoice?.currency }} {{ invoice?.amount }}</span>
              </p>
            </div>
            <div class="row mt-5">
              <div class="col-lg-12">
                <div class="d-flex">
                  <div class="col-md-8 pl-0">
                    <div class="mb-1 color font-size-14 font-weight-bold p-blue">
                      BILLING TO
                    </div>
                    <div>
                      {{ patient?.first_name }} {{ patient?.last_name }}
                    </div>
                    <div>{{ patient?.email_id }}</div>
                    <div>{{ patient?.contact_no }}</div>
                    <div>{{ patient?.address_1 }} {{ patient?.address_2 }}</div>
                    <div>{{ patient?.city_n }} {{ patient?.state }}</div>
                    <div>{{ patient?.zip }}</div>
                  </div>
                  <div class="col-md-4 ml-4">
                    <div>
                      <div class="mb-1 color font-weight-bold font-size-14 p-blue">
                        ISSUE DATE
                      </div>
                      <div>{{ invoice.issue_date }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-5">
              <h5 class="p-blue">Appointment Details</h5>
            </div>
            <table class="items-tbl">
              <tbody>
                <tr class="table-head">
                  <th>DATE</th>
                  <th>TIME</th>
                  <th>DESCRIPTION</th>
                  <th>UNIT PRICE</th>
                  <th>QTY</th>
                  <th>AMOUNT</th>
                </tr>
                <tr class="font-size-14 color">
                  <td>{{ appointment?.apdate | date: dateFormat }}</td>
                  <td>{{ appointment?.aptime }}</td>
                  <td>Online Consulation for 20 mins</td>
                  <td>{{ invoice?.currency }} {{ invoice?.amount }}</td>
                  <td>1</td>
                  <td>{{ invoice?.amount }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <h6>Total</h6>
                  </td>
                  <td>
                    <h6>{{ invoice?.currency }} {{ invoice?.amount }}</h6>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center mt-5">
              <button type="button" class="btn btn-primary pl-3 pl-md-5 pr-3 pr-md-5 btn-lg">
                <a [routerLink]="['/patient/appointment/' + invoice.aptid]" class="text-decoration-none text-white">
                  VIEW APPOINTMENT
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer-new></app-footer-new>
</div>